





































import Vue from 'vue'

import Ace from './AceEditorVue'

import 'ace-builds/src-noconflict/ext-language_tools'
import 'ace-builds/src-noconflict/mode-batchfile'
import 'ace-builds/src-noconflict/mode-diff'
import 'ace-builds/src-noconflict/mode-dockerfile'
import 'ace-builds/src-noconflict/mode-golang'
import 'ace-builds/src-noconflict/mode-groovy'
import 'ace-builds/src-noconflict/mode-html'
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/mode-markdown'
import 'ace-builds/src-noconflict/mode-perl'
import 'ace-builds/src-noconflict/mode-php'
import 'ace-builds/src-noconflict/mode-powershell'
import 'ace-builds/src-noconflict/mode-properties'
import 'ace-builds/src-noconflict/mode-python'
import 'ace-builds/src-noconflict/mode-ruby'
import 'ace-builds/src-noconflict/mode-sh'
import 'ace-builds/src-noconflict/mode-sql'
import 'ace-builds/src-noconflict/mode-xml'
import 'ace-builds/src-noconflict/mode-yaml'
import 'ace-builds/src-noconflict/theme-chrome'

export default Vue.extend({
  name: 'ace-editor',
  components: {Ace},
  props: {
    identifier: String,
    value: String,
    height: String,
    width: String,
    lang: String,
    theme: String,
    codeSyntaxSelectable: Boolean,
    readOnly: Boolean
  },
  data () {
    return {
      valueInternal: this.value || '',
      modeInternal: this.lang || 'text',
      localAce: null,
      aceModes: [
        'batchfile',
        'diff',
        'dockerfile',
        'golang',
        'groovy',
        'html',
        'java',
        'javascript',
        'json',
        'markdown',
        'perl',
        'php',
        'powershell',
        'properties',
        'python',
        'ruby',
        'sh',
        'sql',
        'xml',
        'yaml'
      ]
    }
  },
  watch: {
    valueInternal (newValue, oldValue) {
      this.$emit('input', newValue)
    },
    value (newValue, oldValue) {
      this.valueInternal = newValue
    },
    lang (newValue, oldValue) {
      this.modeInternal = newValue
    }
  },
  methods: {
    aceEditorInit (ace: any) {
      this.localAce = ace
      if(this.readOnly){
        ace.setReadOnly(true)
      }
    }
  }
})
